export class ViewLabInstructions {
	viewLabInstructions: string[];
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/lab/ViewLabInstructions.ts